import { graphql } from '@/gql';
import type { HomeServiceOrderChargeInputType } from '@/gql/graphql';
import { mutationExecute } from '@/Utils/graphqlAPI';
import type { HomeServiceOrderCharge } from '@/models/homeService';

// Fragments
import './fragments/homeServiceOrderChargeFragment';

export const updateHomeServiceOrderCharge = async (id: number, data: HomeServiceOrderChargeInputType) => {
  const response = await mutationExecute({
    variables: {
      id,
      data,
    },
    mutation: graphql(`
      mutation UpdateHomeServiceOrderCharge($id: Float!, $data: HomeServiceOrderChargeInputType!) {
        updateHomeServiceOrderCharge(id: $id, data: $data) {
          ...HomeServiceOrderChargeFragment
        }
      }
    `),
  });

  return response.data?.updateHomeServiceOrderCharge as HomeServiceOrderCharge;
};
